@if (workCenter) {
  <div class="flex layout-col gap-xxl">
    <div class="layout-col gap-md">
      @if (workCenter.labeling.batchItemLabelProvisioning; as provisioningMode) {
        <mat-slide-toggle
          name="batchItemLabelProvisioning"
          [checked]="isProvisioningEnabled(provisioningMode)"
          (change)="handleProvisioningToggleChange($event)"
          [matTooltip]="'labeling.work-center.provisioning-upload' | translate"
        >
          <div class="layout-row place-between-center">
            <h4 class="text-title-medium">ElderFile Upload</h4>
            <mat-icon class="ml-xs">info</mat-icon>
          </div>
        </mat-slide-toggle>

        @if (workCenter.labeling.labelProvisioningOptions) {
          <mat-slide-toggle
            name="excludeContentLabel"
            [disabled]="!isProvisioningEnabled(provisioningMode)"
            [(ngModel)]="workCenter.labeling.labelProvisioningOptions.excludeContentLabels"
            >{{ 'labeling.work-center.omit-content-labels' | translate }}</mat-slide-toggle
          >
        }
      }
    </div>
    @let labelingSpec = labelingSpec$ | async;
    <div class="layout-col gap-md">
      <mat-slide-toggle
        name="labelingOverrideEnabled"
        [checked]="!!labelingSpec"
        (change)="handleOverrideToggleChange($event)"
      >
        <h4 class="text-title-medium">{{ 'labeling.work-center.override' | translate }}</h4>
      </mat-slide-toggle>
      <app-labeling-spec-detail class="flex" [labelingSpec]="labelingSpec">
      </app-labeling-spec-detail>
    </div>
  </div>
}
